module.exports = __webpack_public_path__ + "img/yisheng.086bad8a.svg";